export default __webpack_public_path__ + "static/media/salveowell.67d73b28.png";